const getDefaultState = () => {
  return {
    sessionCount: 0,
    counters: {
      daySessions: 0,
      weekSessions: 0,
      dayStreak: 0,
      weekStreak: 0,
      daysInWeek: 0,
      last7Days: [],
    },
    timezone: "",
  };
};

const state = getDefaultState();

// Synchronous
const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },

  SET_INITIAL_CALENDAR_LOAD_STATS(state, userstats) {
    if (userstats.counters) state.counters = userstats.counters;
    if (userstats.timezone) state.timezone = userstats.timezone;
    if (userstats.sessionCount) state.sessionCount = userstats.sessionCount;
  },

  UPDATE_USER_STREAK_DATA(state, streakData) {
    if (streakData && streakData.counters) {
      state.counters = streakData.counters;
      state.timezone = streakData.timezone;
    }
  },

  SET_TIMEZONE(state, timezone) {
    state.timezone = timezone;
  }
};

// Asynchronous
const actions = {
  resetState({ commit }) {
    commit("RESET_STATE");
  },

  setInitialCalendarLoadStats({ commit }, userstats) {
    commit("SET_INITIAL_CALENDAR_LOAD_STATS", userstats);
  },

  updateUserStreakData({ commit }, streakData) {
    commit("UPDATE_USER_STREAK_DATA", streakData);
  },

  setTimezone({ commit }, timezone) {
    commit("SET_TIMEZONE", timezone);
  }
};

const statistics = {
  namespaced: true,

  state,
  mutations,
  actions,
};

export default statistics;
